export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11321.fd4ef596.jpg";